import type { TTourDefinition } from "./types";

export const TOURS: Record<TTourDefinition["id"], TTourDefinition> = {
  "dashboard-welcome-v1": {
    id: "dashboard-welcome-v1",
    requiredStage: ["no_company", "onboarding_in_progress"],
    autoStart: "firstVisit",
    routes: ["/app"],
    steps: [
      {
        target: '[data-tour="dashboard-getting-started"]',
        title: "Getting started",
        content: "Follow these three steps to activate your account and unlock Fundy's features.",
      },
      {
        target: '[data-tour="sidebar-add-company"]',
        title: "Add a company",
        content: "Click the + button in the sidebar to create your first company and begin onboarding.",
      },
      {
        target: '[data-tour="dashboard-onboarding-cta"]',
        title: "Start onboarding",
        content: "Use this button to start or continue your company onboarding when you're ready.",
      },
    ],
  },
  "onboarding-questions-v1": {
    id: "onboarding-questions-v1",
    requiredStage: ["onboarding_in_progress"],
    autoStart: "firstVisit",
    routes: ["/app/onboarding", "/app/companies/*/onboarding"],
    steps: [
      {
        target: '[data-tour="onboarding-progress"]',
        title: "Track your progress",
        content:
          "This bar shows how many onboarding questions you've answered. Complete all questions to unlock your dashboard.",
      },
      {
        target: '[data-tour="onboarding-messages"]',
        title: "Answer questions",
        content: "Read each question here and provide your answer below. Previous answers stay visible for context.",
      },
      {
        target: '[data-tour="onboarding-input"]',
        title: "Submit your answer",
        content: "Type your response, pick an option, or upload a file depending on the question type. Optional questions can be skipped.",
      },
    ],
  },
  "sidebar-navigation-v1": {
    id: "sidebar-navigation-v1",
    requiredStage: ["onboarding_complete", "activated"],
    autoStart: "firstVisit",
    routes: ["/app"],
    steps: [
      {
        target: '[data-tour="sidebar-company-selector"]',
        title: "Your companies",
        content: "Expand a company to see its sections, dashboards, and chat threads.",
      },
      {
        target: '[data-tour="sidebar-section-list"]',
        title: "Sections",
        content: "Each section has its own dashboard and chat threads tailored to that part of your fundraising journey.",
      },
      {
        target: '[data-tour="sidebar-new-chat"]',
        title: "Start a chat",
        content: "Click New Chat to ask Fundy questions and get AI-powered insights for this section.",
      },
      {
        target: '[data-tour="sidebar-search"]',
        title: "Search",
        content: "Quickly find companies, sections, or past conversations using the search bar.",
      },
    ],
  },
  "chat-interface-v1": {
    id: "chat-interface-v1",
    requiredStage: ["activated"],
    autoStart: "firstVisit",
    routes: ["/app/companies/*/sections/*/threads/*", "/app/companies/*/sections/*/new"],
    steps: [
      {
        target: '[data-tour="chat-messages"]',
        title: "Your conversation",
        content: "Messages appear here. Fundy responds with insights based on your company profile.",
      },
      {
        target: '[data-tour="chat-input"]',
        title: "Ask a question",
        content: "Type your message here and press Send. You can attach files when needed.",
      },
    ],
  },
};

export const TOUR_LIST = Object.values(TOURS);
